export default "__VITE_ASSET__DrmYEZzh__"